import React, { FC } from 'react';

import { Price, Discount } from 'shared-types/Common';
import { DiscountPrice, FromPrice } from '../../Price';
import {
  FooterContainer,
  FooterContent,
  FooterPrice,
  Title,
  Subtitle,
} from './StickyBarContent.styles';

export type StickyBarContentProps = {
  name?: string | JSX.Element;
  subtitle?: string | JSX.Element;
  displayedPrice: Price | null;
  discountedPrice?: Discount | null;
  displayPriceRangeIndicator?: boolean;
  button: JSX.Element;
  isSmall?: boolean;
  /**
   * Display the price as being each, e.g. £31.00 each.
   * - This can be used in the case of multiple quantities of
   * the item being displayed on the page using the sticky bar.
   * - Does not apply when displayPriceRangeIndicator=true.
   */
  showEach?: boolean;
  numberOfGuests?: number;
};

export const StickyBarContent: FC<StickyBarContentProps> = ({
  name,
  subtitle = null,
  displayedPrice,
  discountedPrice,
  button,
  displayPriceRangeIndicator = false,
  isSmall = false,
  showEach = false,
  numberOfGuests,
}) => (
  <FooterContainer data-cy="footer_container_sticky-bar-content" isSmall={isSmall}>
    <FooterContent data-cy="footer_content_sticky-bar-content">
      {subtitle && <Title>{subtitle}</Title>}
      {name && <Subtitle>{name}</Subtitle>}
    </FooterContent>
    <FooterPrice data-cy="footer_price_sticky-bar-content">
      {displayPriceRangeIndicator ? (
        <FromPrice
          data-cy="from-price_sticky-bar-content"
          price={displayedPrice}
          discount={discountedPrice}
          numberOfGuests={numberOfGuests}
        />
      ) : (
        <DiscountPrice
          data-cy="discount-price_sticky-bar-content"
          price={displayedPrice}
          discount={discountedPrice}
          showEach={showEach}
          numberOfGuests={numberOfGuests}
        />
      )}
    </FooterPrice>
    {button}
  </FooterContainer>
);
